export const icertisInstanceHost = (instanceUrl: string): string => {
  const url = new URL(instanceUrl)
  return url.protocol === "https:" ? url.host : url.origin
}
